"use client";

/* eslint-disable simple-import-sort/imports */
import { c as _c } from "react/compiler-runtime";
import { TestIdEnum } from "../../../tests/types";
import type { AvailableFiltersOptions } from "../../api/types/availableFilters";
import type { Filters as FiltersType } from "../../features/filters/types";
import type { Option } from "../../types/selects";
import { CITIES } from "../../constants/cities";
import { selectFilters, selectFiltersStats, useSelector } from "../../store/selectors";
import { useStoreSlices } from "../../store/slices";
import { Button } from "../Button/Button";
import { CloseButton } from "./CloseButton";
import { Tag } from "./Tag";
interface FiltersSummaryProps {
  availableFilters: AvailableFiltersOptions;
}
export const FiltersSummary = t0 => {
  const $ = _c(68);
  const {
    availableFilters
  } = t0;
  const {
    setFilter,
    resetFilters
  } = useStoreSlices();
  const filters = useSelector(selectFilters);
  const stats = useSelector(selectFiltersStats);
  let t1;
  if ($[0] !== availableFilters) {
    t1 = available => ({
      label: availableFilters.availability.find(a => a.value === available)?.label ?? available,
      value: available
    });
    $[0] = availableFilters;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== availableFilters) {
    t2 = caliber => ({
      label: availableFilters.calibers.find(c => c.value === caliber)?.label ?? caliber,
      value: caliber
    });
    $[2] = availableFilters;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== availableFilters) {
    t3 = producer => ({
      label: availableFilters.producers.find(p => p.value === producer)?.label ?? producer,
      value: producer
    });
    $[4] = availableFilters;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== availableFilters) {
    t4 = voivodeship => ({
      label: availableFilters.voivodeship.find(v => v.value === voivodeship)?.label ?? voivodeship,
      value: voivodeship
    });
    $[6] = availableFilters;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== availableFilters) {
    t5 = shop => ({
      label: availableFilters.shops.find(s => s.value === shop)?.label ?? shop,
      value: shop
    });
    $[8] = availableFilters;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const selectedFiltersAsOptions = {
    available: filters.available.map(t1),
    caliber: filters.caliber.map(t2),
    producer: filters.producer.map(t3),
    voivodeship: filters.voivodeship.map(t4),
    shop: filters.shop.map(t5)
  };
  const {
    setMobileFiltersOpen
  } = useStoreSlices();
  let t6;
  if ($[10] !== filters.available || $[11] !== setFilter) {
    t6 = available_0 => {
      setFilter("available", filters.available.filter(a_0 => a_0 !== available_0));
    };
    $[10] = filters.available;
    $[11] = setFilter;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const removeAvailableTag = t6;
  let t7;
  if ($[13] !== filters.caliber || $[14] !== setFilter) {
    t7 = caliber_0 => {
      setFilter("caliber", filters.caliber.filter(c_0 => c_0 !== caliber_0));
    };
    $[13] = filters.caliber;
    $[14] = setFilter;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const removeCaliberTag = t7;
  let t8;
  if ($[16] !== filters.producer || $[17] !== setFilter) {
    t8 = producer_0 => {
      setFilter("producer", filters.producer.filter(p_0 => p_0 !== producer_0));
    };
    $[16] = filters.producer;
    $[17] = setFilter;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const removeProducerTag = t8;
  let t9;
  if ($[19] !== filters.voivodeship || $[20] !== setFilter) {
    t9 = voivodeship_0 => {
      setFilter("voivodeship", filters.voivodeship.filter(v_0 => v_0 !== voivodeship_0));
    };
    $[19] = filters.voivodeship;
    $[20] = setFilter;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  const removeVoivodeshipTag = t9;
  let t10;
  if ($[22] !== filters.shop || $[23] !== setFilter) {
    t10 = shop_0 => {
      setFilter("shop", filters.shop.filter(s_0 => s_0 !== shop_0));
    };
    $[22] = filters.shop;
    $[23] = setFilter;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  const removeShopTag = t10;
  let t11;
  if ($[25] !== stats.appliedFiltersCount) {
    t11 = <p className="text-sm font-black text-slate-900 dark:text-white uppercase tracking-wider">Wybrane filtry: ({stats.appliedFiltersCount})</p>;
    $[25] = stats.appliedFiltersCount;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== setMobileFiltersOpen) {
    t12 = <CloseButton onClick={() => setMobileFiltersOpen(false)} />;
    $[27] = setMobileFiltersOpen;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t11 || $[30] !== t12) {
    t13 = <div data-testid={TestIdEnum.FiltersSummary} className="flex justify-between items-center p-4 pb-0">{t11}{t12}</div>;
    $[29] = t11;
    $[30] = t12;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  const t14 = "flex flex-wrap gap-2 mb-4 px-4";
  const t15 = stats.appliedFiltersCount === 0;
  let t16;
  if ($[32] !== resetFilters || $[33] !== t15) {
    t16 = <Button data-testid={TestIdEnum.FiltersReset} onClick={resetFilters} disabled={t15} variant="secondary" className="text-xs">Resetuj wszystkie</Button>;
    $[32] = resetFilters;
    $[33] = t15;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== filters.city || $[36] !== filters.cityRange || $[37] !== setFilter) {
    t17 = typeof filters.city === "string" && <Tag text={`${CITIES[filters.city]?.city} (${filters.cityRange})`} onClose={() => setFilter("city", undefined)} />;
    $[35] = filters.city;
    $[36] = filters.cityRange;
    $[37] = setFilter;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== filters.priceMin || $[40] !== setFilter) {
    t18 = typeof filters.priceMin === "number" && <Tag text={`Cena od: ${filters.priceMin}`} onClose={() => setFilter("priceMin", undefined)} />;
    $[39] = filters.priceMin;
    $[40] = setFilter;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== filters.priceMax || $[43] !== setFilter) {
    t19 = typeof filters.priceMax === "number" && <Tag text={`Cena do: ${filters.priceMax}`} onClose={() => setFilter("priceMax", undefined)} />;
    $[42] = filters.priceMax;
    $[43] = setFilter;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  let t20;
  if ($[45] !== removeAvailableTag) {
    t20 = t21 => {
      const {
        value: available_1,
        label
      } = t21;
      return <Tag key={available_1} text={label} onClose={() => removeAvailableTag(available_1)} />;
    };
    $[45] = removeAvailableTag;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  const t21 = selectedFiltersAsOptions.available.map(t20);
  let t22;
  if ($[47] !== removeCaliberTag) {
    t22 = t23 => {
      const {
        value: caliber_1,
        label: label_0
      } = t23;
      return <Tag key={caliber_1} text={label_0} onClose={() => removeCaliberTag(caliber_1)} />;
    };
    $[47] = removeCaliberTag;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  const t23 = selectedFiltersAsOptions.caliber.map(t22);
  let t24;
  if ($[49] !== removeProducerTag) {
    t24 = t25 => {
      const {
        value: producer_1,
        label: label_1
      } = t25;
      return <Tag key={producer_1} text={label_1} onClose={() => removeProducerTag(producer_1)} />;
    };
    $[49] = removeProducerTag;
    $[50] = t24;
  } else {
    t24 = $[50];
  }
  const t25 = selectedFiltersAsOptions.producer.map(t24);
  let t26;
  if ($[51] !== removeVoivodeshipTag) {
    t26 = t27 => {
      const {
        value: voivodeship_1,
        label: label_2
      } = t27;
      return <Tag key={voivodeship_1} text={label_2} onClose={() => removeVoivodeshipTag(voivodeship_1)} />;
    };
    $[51] = removeVoivodeshipTag;
    $[52] = t26;
  } else {
    t26 = $[52];
  }
  const t27 = selectedFiltersAsOptions.voivodeship.map(t26);
  let t28;
  if ($[53] !== removeShopTag) {
    t28 = t29 => {
      const {
        value: shop_1,
        label: label_3
      } = t29;
      return <Tag key={shop_1} text={label_3} onClose={() => removeShopTag(shop_1)} />;
    };
    $[53] = removeShopTag;
    $[54] = t28;
  } else {
    t28 = $[54];
  }
  const t29 = selectedFiltersAsOptions.shop.map(t28);
  let t30;
  if ($[55] !== t16 || $[56] !== t17 || $[57] !== t18 || $[58] !== t19 || $[59] !== t21 || $[60] !== t23 || $[61] !== t25 || $[62] !== t27 || $[63] !== t29) {
    t30 = <div className={t14}>{t16}{t17}{t18}{t19}{t21}{t23}{t25}{t27}{t29}</div>;
    $[55] = t16;
    $[56] = t17;
    $[57] = t18;
    $[58] = t19;
    $[59] = t21;
    $[60] = t23;
    $[61] = t25;
    $[62] = t27;
    $[63] = t29;
    $[64] = t30;
  } else {
    t30 = $[64];
  }
  let t31;
  if ($[65] !== t13 || $[66] !== t30) {
    t31 = <>{t13}{t30}</>;
    $[65] = t13;
    $[66] = t30;
    $[67] = t31;
  } else {
    t31 = $[67];
  }
  return t31;
};